import {
  Badge,
  Theme,
} from "@120wateraudit/waterworks";
import React from "react";

const LEAD_MATERIALS = ["Lead", "Lead-Lined Galvanized Iron/Steel"];
const NON_LEAD_MATERIALS = [
  "Asbestos",
  "Cast Iron",
  "Concrete",
  "HDPE",
  "PB",
  "PE",
  "PVC",
  "Steel",
  "No Lead",
  "N/A",
  "N/A - Single Ownership",
  "Wrought Iron",
  "Ductile Iron",
  "Other",
  "Copper",
  "Brass",
  "Plastic",
];
const LEAD_STATUS_UNKNOWN_MATERIALS = [
  "Likely GI",
  "Likely Non-lead",
  "Likely Lead",
  "Unknown",
  "Unknown - Material Unknown",
  "Unknown - Likely Lead",
  "Unknown - Unlikely Lead",
];
const GALVANIZED_MATERIALS = [
  "Galvanized Iron",
  "Galvanized Iron/Steel - Requiring Replacement",
  "Galvanized Iron/Steel - Lead Contact Unknown",
];

const getColorForMaterial = (material: string): string => {
  if (NON_LEAD_MATERIALS.includes(material)) {
    return Theme.palette.primary;
  }

  if (LEAD_STATUS_UNKNOWN_MATERIALS.includes(material)) {
    return Theme.palette.secondary;
  }

  if (GALVANIZED_MATERIALS.includes(material)) {
    return Theme.palette.tertiary;
  }

  if (LEAD_MATERIALS.includes(material)) {
    return Theme.palette.warning;
  }

  return Theme.palette.primary;
};

interface MaterialBadgeProps {
  material: string;
  inverse?: boolean;
  minWidth?: string;
  padding?: string;
}

export const MaterialBadge: React.FC<MaterialBadgeProps> = ({
  material,
  inverse = false,
  minWidth,
  padding,
}) => {
  const bgColor = inverse ? Theme.palette.white : getColorForMaterial(material);

  let textColor: string;
  if (inverse) {
    textColor = getColorForMaterial(material);
  } else if (bgColor === Theme.palette.warning) {
    textColor = Theme.palette.white;
  } else if (bgColor === Theme.palette.primary || bgColor === Theme.palette.tertiary) {
    textColor = Theme.palette.neutral900;
  } else if (bgColor === Theme.palette.secondary) {
    textColor = Theme.palette.white;
  } else {
    textColor = Theme.palette.white;
  }

  const badgeStyle: React.CSSProperties = {
    justifyContent: inverse ? "left" : "center",
    padding: padding ?? "0px",
    fontWeight: inverse ? "bold" : "normal",
    textAlign: "center",
    minWidth: minWidth ?? "initial",
  };

  return (
    <Badge
      style={badgeStyle}
      color={textColor}
      backgroundColor={bgColor}
    >
      {material}
    </Badge>
  );
};

export default MaterialBadge;
